import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import Select from 'react-select';

export default function TerritoryChecksBrandSelect({ options, selectedId }) {
  const selectOptions = options.map(({ id, name }) => ({ value: id, label: name }));
  const [selected, setSelected] = useState(
    selectOptions.find((option) => String(option.value) === String(selectedId)) || null
  );

  return (
    <>
      <Select
        classNamePrefix="brand-select"
        styles={{ container: (base) => ({ ...base, minWidth: 220 }) }}
        options={selectOptions}
        value={selected}
        onChange={setSelected}
        placeholder="Brand Name"
        isClearable
      />
      <input type="hidden" name="division_id" value={selected?.value || ''} />
    </>
  );
}

const element = document.getElementById('territory-checks-brand-select');
if (element) {
  const options = JSON.parse(element.dataset.options || '[]');
  const selectedId = element.dataset.selected || '';
  const root = createRoot(element);
  root.render(<TerritoryChecksBrandSelect options={options} selectedId={selectedId} />);
}
